import { StateService } from './../../services/state.service';
import { CountryService } from './../../services/country.service';
import { environment } from './../../../environments/environment.prod';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { FormService } from './../../services/form.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Http , Response , Headers} from '@angular/http';

import { FontsService } from 'src/app/services/fonts.service';
import {LanguageService} from './../../services/language.service';
// declare var $: any;


@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent implements OnInit {

  f: FormGroup;
  apiUrl = environment.apiURL;
  brandId = environment.brandId;
  formstatelist: any;
  countrylist: any;
  searchString:any;
  dietaryRestrictions:any="";
  language:any;
  disableSubmitForGhost:boolean=false;
  errormessage: string;
  iserror: boolean;
  filter:any={};

  constructor(private languageService:LanguageService,private formBuilder: FormBuilder, private formSevice: FormService,
    private http: HttpClient, private stateService: StateService, private  countryService: CountryService,
    private fontService: FontsService ) {}

  @Input() eventid: number;
  @Input() searchstring:any;
  @Output() childeventid = new EventEmitter<number>();
  @Output() desceventid = new EventEmitter<number>();
  @Output() sucesseventid = new EventEmitter<number>();

  isshow: boolean[] = [];
  model: any = {};
  formData: any;
  questionOne;
  questionTwo;
  questionThree;
  questionOneOptions;
  questionTwoOptions;
  questionThreeOptions;
  scrollResult;

  onSubmit(form: NgForm) {
    
    if(this.eventid==0){
      this.http.get(this.apiUrl + 'attendees/checkghostemail?email='+this.model.email)
      .subscribe(response => {
       if(response['data'][0].totCnt>=1){
        this.disableSubmitForGhost = true;
       }
       else{
        console.log("") 
        console.log("============>>>>>>>>>>>>>>>>>>>>>",NgForm);
        console.log(this.model.state.optionId);
        const attendeePostObject = {
          firstName: this.model.firstName,
          lastName: this.model.lastName,
          email : this.model.email,
          country : this.model.selectedValue,
          address : this.model.address,
          city : this.model.city,
          addressTwo : this.model.addressTwo,
          state : this.model.state,
          zipCode : this.model.zipCode,
          brandId : this.brandId,
          eventId : this.eventid,
          optIn:this.model.permission?1:0,
          ans: this.model.answerOne.optionId + ' ,' + this.model.answerTwo.optionId,
          dietaryRestrictions:this.model.dietaryRestrictions?this.model.dietaryRestrictions:"",
          travelMiles:this.model.miles
        };
      
      
        this.http.post(this.apiUrl + 'attendees', attendeePostObject)
          .subscribe(response => {
            console.log(response);
            this.isshow[this.eventid] = true;
            this.desceventid.emit(this.eventid);
            this.scroll();
            this.iserror = false;
      
          }, (err: HttpErrorResponse) => {
            console.log(err);
            this.iserror = true;
            if (err.status === 409) {
              this.errormessage = 'Sorry you have already registered for this Event';
            }
        });
       }
    
      });
      
    }
    else{
        console.log("") 
        console.log("============>>>>>>>>>>>>>>>>>>>>>",NgForm);
        console.log(this.model.state.optionId);
        console.log("this.model.state,>>>>>>>>>>",this.model.state);

        const attendeePostObject = {
          firstName: this.model.firstName,
          lastName: this.model.lastName,
          email : this.model.email,
          country : this.model.selectedValue,
          address : this.model.address,
          city : this.model.city,
          addressTwo : this.model.addressTwo,
          state : this.model.state,
          zipCode : this.model.zipCode,
          brandId : this.brandId,
          eventId : this.eventid,
          optIn:this.model.permission?1:0,
          ans: this.model.answerOne.optionId + ' ,' + this.model.answerTwo.optionId,
          dietaryRestrictions:this.model.dietaryRestrictions?this.model.dietaryRestrictions:"",
          travelMiles:this.model.miles
        };


        this.http.post(this.apiUrl + 'attendees', attendeePostObject)
          .subscribe(response => {
            console.log(response);
            this.isshow[this.eventid] = true;
            this.desceventid.emit(this.eventid);
            this.scroll();
            this.iserror = false;

          }, (err: HttpErrorResponse) => {
            console.log(err);
            this.iserror = true;
            if (err.status === 409) {
              this.errormessage = 'Sorry you have already registered for this Event';
            }
        });
  }
  }

  disableGhostError(){
    this.disableSubmitForGhost = false;
  }

  onEmailBlur(){
    this.disableSubmitForGhost = false;
    console.log("Event ID>>>>>",this.eventid);
   if(this.eventid==0){

        this.http.get(this.apiUrl + 'attendees/checkghostemail?email='+this.model.email)
        .subscribe(response => {
          console.log(response);
        if(response['data'][0].totCnt>=1){
          this.disableSubmitForGhost = true;
        }

        }, (err: HttpErrorResponse) => {
          console.log(err);
          this.iserror = true;
          if (err.status === 409) {
            
          }
        });
   } 
  }

  gotoTop() {   
   /* window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });*/
  }
  scroll(){
    this.isshow[this.eventid] = true;
    // let el = document.querySelector(".ThanksPage");
    console.log(" document.querySelector()", document.querySelector(".ram"));
    document.querySelector(".ram").scrollIntoView();
    // el.scrollIntoView();
  }

  ngOnInit() {

            if(this.searchstring){
              this.getformInfo();
            }

            if(this.eventid == 0){

              this.filter.questionType = 2;
            }else{
              
              this.filter.questionType = 1;
            }
          
          this.languageService.currenLanguage.subscribe((result:any)=>{

            console.log("header",result);

            this.language = result;

          })


          this.errormessage = '';
          this.iserror = false;
          this.formSevice.getFormData(this.filter).subscribe((response: any) => {
            this.formData = response.data.data;
            this.questionOne = this.formData[0]['question'];
            this.questionTwo = this.formData[1]['question'];
            //  this.questionThree = this.formData[2]['question'];
            this.questionOneOptions = this.formData[0]['options'];
            this.questionTwoOptions = this.formData[1]['options'];
            //  this.questionThreeOptions = this.formData[2]['options'];
          }, (error) => { console.log(error);
          });

          this.stateService.getStates().subscribe((response: any) => {
            this.formstatelist = response.data.data;
            console.log('Form', this.formstatelist);
            }, (error) => {console.log(error);
          });

        this.countryService.getCountries().subscribe((response: any) => {
              this.countrylist = response.data.data;
              console.log(this.countrylist);
              this.model.selectedValue = this.countrylist['230'].id;
              console.log(this.model.selectedValue);
          }, (error) => {console.log(error); }
        );
          this.isshow[this.eventid] = false;
  }

  onCancel() {
    this.childeventid.emit(this.eventid);
    this.isshow[this.eventid] = false;
    this.iserror = false;
  }
  aftersucess(event: any) {
    console.log('form' + event);
    this.sucesseventid.emit(event);
    this.isshow[event] = false;
    this.iserror = false;
  }
  searchWithCode(e) {
    console.log('e', e.target.value);
    this.model.country.id = e.target.value;
  }

  public headerStyleObject = (): any => {
    return this.fontService.getHeaderStyleObject();
  }

  public spanPinkStyleObject = (): any => {
    return this.fontService.getSpanPinkStyleObject();
  }

  public header3StyleObject = (): any => {
    return this.fontService.getHeader3StyleObject();
  }

  public header4StyleObject = (): any => {
    return this.fontService.getHeader4StyleObject();
  }

  public header5StyleObject = (): any => {
    return this.fontService.getHeader5StyleObject();
  }

  public topicHeaderStyleObject = (): any => {
    return this.fontService.getTopicHeaderStyleObject();
  }

  public titleStyleObject = (): any => {
    return this.fontService.getTitleStyleObject();
  }

  getformInfo(){

    this.http.get(this.apiUrl + 'attendees/getattendeedetails?searchString='+this.searchstring)
    .subscribe((response:any) => {
     this.searchstring=undefined;
      console.log("1234",response.data[0]);
  
      this.model.firstName=response.data[0].first_name;
      this.model.state=response.data[0].state_id;
      this.model.email=response.data[0].email;
      this.model.lastName =response.data[0].last_name;
      this.model.address = response.data[0].address;
      this.model.city = response.data[0].city;
      this.model.zipCode = response.data[0].zip;
      this.model.confirmZipCode= response.data[0].zip;
      this.model.address2 = response.data[0].address2;
     

    }, (err: HttpErrorResponse) => {
        console.log(err);
      
        if (err.status === 409) {
          
        }
    });

}

  
}

